<template>
  <el-dialog :title='title' :visible.sync="dialogVisible" :close-on-click-modal="false" @close="initData" width="80rem">
    <div class="cover-box" v-if="form.type != '图片'">
      <div>资源封面</div>
      <el-upload style="width: 50px !important; height: 50px !important" action="#" accept=".jpg,.jpeg,.png"
        list-type="picture-card" :auto-upload="false" :show-file-list="false" class="upload-box-img"
        :on-change="handleFm">
        <img v-if="form.coverPath" :src="$severUrl(form.coverPath)" style="width: 48px; height: 48px" />
        <i v-else class="el-icon-plus"></i>
      </el-upload>
    </div>
    <div class="resource-name">
      <div>资源名称</div>
      <el-input style="width: 20rem;" v-model="form.resourceName" placeholder="请输入资源名称"></el-input>
    </div>
    <div class="resource-name" style="border-bottom: 1px solid #EAEBF0;">
      <div>资源介绍</div>
      <el-input style="width: 100%;" type="textarea" v-model="form.info" placeholder="请输入资源介绍"></el-input>
    </div>
    <div class="item">
      <div>所属分类</div>
      <el-radio-group v-model="form.resourceCategory">
        <el-radio :label="item.value" v-for="(item, index) in Category" :key="index">{{ item.label }}</el-radio>
      </el-radio-group>
    </div>
    <div class="item">
      <div>资源类型</div>
      <el-radio-group v-model="form.type">
        <el-radio :label="item.value" v-for="(item, index) in typeOptions" :key="index">{{ item.label }}</el-radio>
      </el-radio-group>
    </div>
    <div class="item" v-if="form.type == '仿真软件'">
      <div>资源链接</div>
      <el-input style="width: 20rem;" v-model="form.url" placeholder="请输入资源链接"></el-input>
    </div>
    <div class="upload-box" v-else>
      <upload-chunk :multiple="false" ref="chunk" :accept="accept" @upload="upload" @del_file="upload"></upload-chunk>
    </div>
    <div class="btn-box">
      <el-button size="large" @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" v-debounce="save" size="large" style="margin-left: 3.5rem;">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { uploadFile } from '@/assets/js/oss';
import UploadChunk from '../../common/UploadChunk.vue';
import { UpdateResource, AddResource } from '@/api/resourceMag';
import { Category } from '@/utils/utils';
export default {
  components: { UploadChunk },
  props: ['resourceType'],
  data() {
    return {
      Category,
      title: '上传资源',
      operation: '',
      resourceId: '',
      dialogVisible: false,
      form: {
        resourceCategory: 'CIS',
        type: 'ppt',
        info: '',
        resourceName: '',
        coverPath: '',
        coverFileId: '',
        fileList: null,
        url: '',
      },
      /**资源类型 */
      typeOptions: [
        {
          label: 'PPT',
          value: 'ppt'
        },
        {
          label: '动画',
          value: '动画'
        },
        {
          label: '模型',
          value: '模型'
        },
        {
          label: '文档',
          value: '文档'
        },
        {
          label: '视频',
          value: '视频'
        },
        {
          label: '图片',
          value: '图片'
        }
      ]
    }
  },
  methods: {
    initData() {
      var dialog = this.$refs.chunk;
      dialog.fileArr = [];
      this.operation = '';
      this.resourceId = '';
      this.form.coverPath = '';
      this.form.coverFileId = '';
      this.form.info = '';
      this.form.resourceName = '';
      this.form.fileList = null;
    },
    setChunkDefault(data) {
      var dialog = this.$refs.chunk;
      this.form.fileList = {
        name: data.fileName,
        id: data.id
      };
      if (dialog) {
        dialog.fileArr = [data];
      }
    },
    /**上传封面 */
    handleFm(e) {
      uploadFile(e.raw).then(res => {
        this.form.coverPath = res.fileUrl;
        this.form.coverFileId = res.id;
      })
    },
    removeFile() {
      this.form.fileList = null;
    },
    /**校验 */
    verification() {
      var obj = {
        resourceName: '资源名称不能为空',
        resourceCategory: '所属分类不能为空',
        fileList: '上传文件不能为空'
      }
      if (this.form.type == '仿真软件') {
        delete obj.fileList;
        obj.url = '资源链接不能为空';
      }
      for (let key in obj) {
        if (!this.form[key]) {
          this.$msg({
            showClose: true,
            message: obj[key],
            type: "warning",
          });
          return false;
        }
      }
      return true;
    },
    upload(e) {
      if (e && e.length > 0) {
        var file = e[0];
        if (!this.form.resourceName) {
          this.form.resourceName = file.fileName;
        }
        this.form.fileList = {
          name: file.fileName,
          id: file.id
        }
      } else {
        this.form.fileList = null;
      }
    },
    save() {
      if (!this.verification()) return;
      var params = {
        "coverFileId": this.form.coverFileId,
        "coverPath": this.form.coverPath,
        "info": this.form.info,
        "classifyCode": this.form.resourceCategory,
        "resUrl": '',
        "resourceCode": "",
        "resourceName": this.form.resourceName,
        "type": this.form.type,
      }
      if (this.form.type == '仿真软件') {
        params.url = this.form.url;
      } else {
        params.fileIds = [this.form.fileList.id];
        params.fileName = this.form.fileList.name;
        if (this.form.type == '图片') {
          delete params.coverPath;
          delete params.coverFileId;
        }
      }
      if (this.operation == 'edit') {
        params.id = this.resourceId;
        UpdateResource(params).then(res => {
          if (res.code == 200) {
            this.$msg({
              showClose: true,
              message: "修改资源成功",
              type: "success",
            });
            this.dialogVisible = false;
            this.$emit('create_resource');
            return;
          }
        })
      } else {
        AddResource(params).then(res => {
          if (res.code == 200) {
            this.$msg({
              showClose: true,
              message: "创建资源成功",
              type: "success",
            });
            this.dialogVisible = false;
            this.$emit('create_resource', {
              resourceName: res.data.resourceName,
              resourceId: res.data.resourceId,
              classifyCode: this.form.resourceCategory
            });
          }
        })
      }
    }
  },
  computed: {
    accept() {
      var obj = {
        'ppt': '.ppt,.pptx',
        '视频': '.mp4,.avi,.ts,.flv,.avi,.wmv',
        "动画": '.FBX,.obj,.gltf,.stl,.collada,.ply,.three',
        "模型": '.FBX,.obj,.gltf,.stl,.collada,.ply,.three',
        '文档': '.doc,.docx,.pdf,.xls,.xlsx',
        '图片': '.png,.jpg,.jpeg',
        '仿真软件': '.exe'
      }
      return obj[this.form.type] || '';
    }
  }
}
</script>

<style lang="less" scoped>
.cover-box {
  margin-bottom: 3rem;
  display: flex;
  align-items: center;
  color: #8590B3;

  &> :nth-child(1) {
    margin-right: 1rem;
  }
}

.upload-box-img {
  /deep/.el-upload {
    width: 50px;
    height: 50px;
    position: relative;
  }

  /deep/.el-icon-plus {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

/deep/.el-dialog__title {
  color: #334681;
  font-weight: 700;
  font-size: 16px;
}

/deep/.el-dialog {
  border-radius: 16px;
}

// /deep/.el-upload{
//   width: 100%;
// }
// /deep/.el-upload-dragger{
//   height: 34rem;
// }
// /deep/.el-icon-upload{
//   margin: 11rem 0 16px;
// }
.resource-name {
  display: flex;
  padding-bottom: 2.8rem;

  &> :nth-child(1) {
    margin-right: 1rem;
    color: #8590B3;
    font-size: 14px;
  }
}

.item {
  display: flex;
  align-items: center;
  margin-top: 3rem;

  &> :nth-child(1) {
    color: #334681;
    font-size: 14px;
    margin-right: 1rem;
  }
}

.upload-box {
  margin-top: 3rem;
}

.tip {
  color: #8590B3;
  font-size: 14px;
  margin-top: 0.5rem;
}

.btn-box {
  margin: 3.5rem 0;
  text-align: center;
}

/deep/.el-upload--picture-card {
  border: 1px solid #e8ecef;
  background: #ffffff;
}

/deep/.el-dialog__header {
  background-image: url('../../../assets/image/magSys/top.png');
  border-top-right-radius: 16px;
}

/deep/.el-input--small .el-input__inner {
  height: 4rem;
  border-radius: 1rem;
}

.el-icon-plus {
  font-size: 1rem;
}
</style>